import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useProperties, useStats } from 'state';
import { formatCurrencyGB } from 'helpers/formatNumber';
import ScrollControl from '../ScrollControl';
import StatItem from '../StatItem';
import styles from './StatCarousel.module.scss';

/**
 * StatCarousel
 *
 * @return {JSX.Element}
 */
const StatCarousel = ({ className }) => {
  const { data } = useStats();
  const propertiesState = useProperties();

  const items = [
    { label: 'Properties', value: propertiesState.data.length },
    { label: 'Tenancies', value: propertiesState.tenanciesCount },
    { label: 'Future Tenancies', value: data.tenancies.future },
    { label: 'Active Tenancies', value: data.tenancies.active },
    { label: 'Ended Tenancies', value: data.tenancies.ended },
    { label: 'Occupancy', value: `${data.properties.occupiedPercentage}%` },
    { label: 'Occupied Properties', value: data.properties.occupied },
    {
      label: 'Monthly Rent Income',
      value: formatCurrencyGB(data.rent.expectedActiveMonthly),
    },
    { label: 'Total Rent Received', value: formatCurrencyGB(data.rent.total) },
    {
      label: 'Total Deposits Received',
      value: formatCurrencyGB(data.deposits.total),
    },
    {
      label: 'Deposits Protected',
      value: formatCurrencyGB(data.deposits.totalProtected),
    },
    { label: 'Agreements Signed', value: data.tenancies.agreementsSigned },
    { label: 'Total Tenants', value: data.tenants.total },
    { label: 'Tenants Linked', value: data.tenants.totalLinked },
  ];

  return (
    <ScrollControl
      className={classNames(
        styles.StatCarousel,
        className,
        StatCarousel.displayName
      )}
      horizontal
      controls={250}
    >
      {items.map((item) => (
        <StatItem key={item.label} {...item} />
      ))}
    </ScrollControl>
  );
};

StatCarousel.displayName = 'StatCarousel';

export default observer(StatCarousel);
